// @flow
/* -------------------- Globals ----------------*/
import produce from 'immer';

/* -------------------- Action Types ----------------*/
import {
  START_SESSION,
  SESSION_LOADED,
  SESSION_ERROR,
  RESET_SESSION_CREATED,
  SET_PROGRESS_BAR,
  SET_ANSWEREVENT_STATUS,
} from './actionTypes';
import { RESET_APP } from '../actionTypes';

/* -------------------- Types ----------------*/
import initialState from './constants';
import type { StudySetState } from './types';

const handleSessionLoading = (
  state: StudySetState,
  data: StudySetState,
) => produce(state, (draft) => {
  draft.sessionLoading = data.sessionLoading;
  draft.studyMode = data.studyMode;
  draft.inReverseMode = data.inReverseMode;
});

const handleSetAnswerEventStatus = (
  state: StudySetState,
  data: boolean,
) => produce(state, draft => {
  draft.answerEventInProgress = data;
});
const handleSetProgressBarValue = (
  state: StudySetState,
  value: number,
) => produce(state, (draft) => {
  draft.progressBarValue = value;
});
const handleReset = state => produce(state, () => ({
  ...initialState,
}));

const handleResetSessionCreated = state => produce(state, (draft) => {
  draft.sessionCreated = false;
});
const handleSessionError = (state, overallPermission) => produce(
  state,
  (draft) => {
    draft.sessionCreationFailed = true;
    draft.sessionLoading = false;
    draft.overallPermission = overallPermission;
  },
);
const handleSessionLoaded = (
  state: StudySetState,
  data: StudySetState,
) => produce(state, (draft) => {
  const {
    nextScreen,
    redirectUrl,
    sessionId,
    sessionCreated,
    hasMultipleContent,
    overallPermission,
    sessionType,
    isSchedule,
  } = data;
  draft.sessionLoading = false;
  draft.sessionCreated = sessionCreated;
  draft.nextScreen = nextScreen;
  draft.redirectUrl = redirectUrl;
  draft.sessionId = sessionId;
  draft.hasMultipleContent = state.hasMultipleContent || hasMultipleContent;
  draft.overallPermission = overallPermission;
  draft.sessionType = sessionType;
  draft.isSchedule = isSchedule;
});

const studySetReducer = (
  state: StudySetState = { ...initialState },
  action: *,
) => {
  switch (action.type) {
    case START_SESSION:
      return handleSessionLoading(state, action.data);
    case SESSION_LOADED:
      return handleSessionLoaded(state, action.data);
    case RESET_APP:
      return handleReset(state);
    case SESSION_ERROR:
      return handleSessionError(
        state,
        action.data,
      );
    case SET_PROGRESS_BAR:
      return handleSetProgressBarValue(
        state,
        action.data,
      );
    case RESET_SESSION_CREATED:
      return handleResetSessionCreated(
        state,
      );
    case SET_ANSWEREVENT_STATUS:
      return handleSetAnswerEventStatus(
        state,
        action.data,
      );
    default:
      return state;
  }
};

export default studySetReducer;
